// config.js
const isDev = process.env.NODE_ENV !== 'production';

const config = {
  apiBaseUrl: isDev
    ? 'http://localhost:3001/api' // URL do proxy local
    : 'https://marrariprox.azurewebsites.net', // URL de produção (sem proxy)
};

export default config;
